import entitiesSearch from 'app/modules/search/sagas/entitiesSearch';
import txnEventsSearch from 'app/modules/search/sagas/txnEventsSearch';
import teamsSearch from 'app/modules/search/sagas/teamsSearch';

const sagaRegistry = [entitiesSearch, txnEventsSearch, teamsSearch];

export default sagaRegistry;
